var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefinery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 59 56",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "039---Refinery",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 26c-.5522847 0-1-.4477153-1-1v-4c0-1.6568542-1.3431458-3-3-3h-12c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h12c2.7600532.0033061 4.9966939 2.2399468 5 5v4c0 .5522847-.4477153 1-1 1z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 8c-.5522847 0-1-.44771525-1-1v-3c0-1.1045695-.8954305-2-2-2h-8c-1.1045695 0-2 .8954305-2 2v3c0 .55228475-.4477153 1-1 1s-1-.44771525-1-1v-3c0-2.209139 1.790861-4 4-4h8c2.209139 0 4 1.790861 4 4v3c0 .55228475-.4477153 1-1 1z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25 36v-24c0-2.76142375 2.2385763-5 5-5s5 2.23857625 5 5v24z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m11 37v-25c0-2.76142375 2.2385763-5 5-5s5 2.23857625 5 5v25z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 12v1h-10v-1c0-2.76142375 2.2385763-5 5-5s5 2.23857625 5 5z",
    fill: "#2fa8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m21 12v1h-10v-1c0-2.76142375 2.2385763-5 5-5s5 2.23857625 5 5z",
    fill: "#2fa8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 14h-27c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h27c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16 27.8v8.2l-14.47-9.044c-.30766217-.1922934-.69534233-.2028629-1.0130248-.0276184-.31768247.1752444-.51552661.508809-.5169752.8716184v27.2c0 .5522847.44771525 1 1 1h35c.5522847 0 1-.4477153 1-1v-18c0-.5522847-.4477153-1-1-1h-4l-14.47-9.044c-.3076622-.1922934-.6953423-.2028629-1.0130248-.0276184-.3176825.1752444-.5155266.508809-.5169752.8716184z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2fa8cc"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    height: 7,
    rx: 1,
    width: 7,
    x: 4,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    height: 7,
    rx: 1,
    width: 7,
    x: 15,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    height: 7,
    rx: 1,
    width: 7,
    x: 26,
    y: 45
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57 31v23c-.0032948 1.1032019-.8967981 1.9967052-2 2h-12c-1.1032019-.0032948-1.9967052-.8967981-2-2v-23c0-4.418278 3.581722-8 8-8s8 3.581722 8 8z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 45v11h-2v-11c0-.5522847.4477153-1 1-1s1 .4477153 1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 40c-.5522847 0-1-.4477153-1-1v-7c0-.5522847.4477153-1 1-1s1 .4477153 1 1v7c0 .5522847-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7.93 30.96-1.86-26.03c-.04196557-.52230157-.47603063-.92598208-1-.93h-2.141c-.52463093-.00143827-.96117914.40280537-1 .926l-1.929 26.074z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57 31v1h-16v-1c0-4.418278 3.581722-8 8-8s8 3.581722 8 8z",
    fill: "#2fa8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 33h-18c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h18c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 37v4h-37v-13.2c.00288878-.3620925.20129671-.694335.51870937-.8686008.31741265-.1742658.70423444-.1633259 1.01129063.0286008l13.58 8.48.89.56v-8.2c.0028888-.3620925.2012967-.694335.5187094-.8686008.3174126-.1742658.7042344-.1633259 1.0112906.0286008l14.47 9.04h4c.5522847 0 1 .4477153 1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m8 35c0 .5522847-.44771525 1-1 1h-7v-2h7c.55228475 0 1 .4477153 1 1z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m24 35c0 .5522847-.4477153 1-1 1h-7v-2h7c.5522847 0 1 .4477153 1 1z",
    fill: "#e57e25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinery);
export default __webpack_public_path__ + "static/media/refinery.0be56695129baaef5d6c9acf3874ebe1.svg";
export { ForwardRef as ReactComponent };